import { render, staticRenderFns } from "./PrintUsers.vue?vue&type=template&id=45abee28&scoped=true&"
import script from "./PrintUsers.vue?vue&type=script&lang=ts&"
export * from "./PrintUsers.vue?vue&type=script&lang=ts&"
import style0 from "./PrintUsers.vue?vue&type=style&index=0&id=45abee28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abee28",
  null
  
)

export default component.exports